import React from 'react';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';

const Testimonials = () => {
  return (
    <section id="indkoersel" className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Text Content - Col 6 */}
          <div className="order-1 md:order-1">
            <h2 className="text-orange-600 font-bold tracking-wider uppercase text-sm mb-3">
              Specialist i indkørsler
            </h2>
            <h3 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6 leading-tight">
              Få en indkørsel der holder i årevis og byder velkommen
            </h3>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              Jeg skaber indkørsler, der kombinerer æstetik med ekstrem holdbarhed. 
              Uanset om du ønsker klassiske herregårdssten, moderne store fliser eller noget helt tredje, 
              sikrer jeg et korrekt og stabilt fundament, der modstår det danske vejr.
            </p>
            
            <ul className="space-y-4 mb-10">
              {[
                "Korrekt bundsikring for maksimal stabilitet",
                "Præcis belægning med øje for detaljen",
                "Effektiv afvanding og faldsikring",
                "Materialer af højeste kvalitet"
              ].map((item, index) => (
                <li key={index} className="flex items-center gap-3 text-slate-700 font-medium">
                  <CheckCircle2 className="w-5 h-5 text-orange-600 flex-shrink-0" />
                  {item}
                </li>
              ))}
            </ul>

            <Link 
              to="/ydelser/indkoersel" 
              className="inline-flex items-center gap-2 bg-slate-900 text-white px-8 py-4 rounded-lg font-bold hover:bg-orange-600 transition-colors group"
            >
              Læs mere om indkørsler
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>

          {/* Image Content - Col 6 */}
          <div className="order-2 md:order-2">
            <div className="rounded-2xl overflow-hidden shadow-2xl w-full aspect-[4/3] md:aspect-[3/4] lg:aspect-[4/5] min-h-[400px] md:min-h-[600px] relative">
              <img 
                src="https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/c44311e0-ab36-48d7-b71e-cf49ea50338d.jpg" 
                alt="Professionel belægning af indkørsel" 
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
